import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { datadogRum } from '@datadog/browser-rum';
import { environment } from '@environments/environment';

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));


datadogRum.init({
  applicationId: environment.datadog.applicationId,
  clientToken: environment.datadog.clientToken,
  //site: environment.datadog.site, 
  service: environment.datadog.service,
  env: environment.datadog.env,
  version: environment.datadog.version,
  //sampleRate: environment.datadog.sampleRate,
  sessionReplaySampleRate: environment.datadog.sessionReplaySampleRate,
  //trackInteractions: environment.datadog.trackInteractions,
  trackResources: environment.datadog.trackResources,
  trackLongTasks: environment.datadog.trackLongTasks,
  defaultPrivacyLevel: environment.datadog.defaultPrivacyLevel,
  //trackFrustrations: environment.datadog.trackFrustrations,
  enableExperimentalFeatures: environment.datadog.enableExperimentalFeatures,
  allowedTracingUrls: environment.datadog.allowedTracingUrls
});
datadogRum.startSessionReplayRecording();
  